<template>
  <ManageBankAccountManageTab @update="handleUpdate"></ManageBankAccountManageTab>
</template>

<script>
import ManageBankAccountManageTab from './components/ManageBankAccountManageTab.vue'

export default {
  name: 'AdminMemberAccountManagement',
  components: {
    ManageBankAccountManageTab,
  },
  data() {
    return {
      // 当前激活的标签页
      activeTab: 'bankCard',
    }
  },
  methods: {
    // 处理子组件更新事件
    handleUpdate() {
      this.$message.info('数据已更新')
    },
  },
}
</script>

<style scoped>
.account-management-container {
  padding: 0 20px;
}

.other-account-section {
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
